module.exports = __webpack_public_path__ + "img/banner_mobile_EN.84ad06f3.png";